import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromCart,
  updateCartQty,
} from "../data/actions/cart";
import { Link, useHistory } from "react-router-dom";

const Cart = () => {
  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cart?.cart || []);
  const isAuthenticated = useSelector(
    (state) => state.auth?.isAuthenticated
  );

  const history = useHistory();

  const total = cartItems.reduce(
    (sum, item) =>
      sum + (item.finalPrice || item.price) * item.quantity,
    0
  );

  // EMPTY CART
  if (cartItems.length === 0) {
    return (
      <section className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">
            Your cart is empty 🛒
          </h2>
          <Link
            to="/shop"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg"
          >
            Continue Shopping
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="min-h-screen bg-gray-50 py-10">
      <div className="max-w-6xl mx-auto px-4">

        <h1 className="text-3xl font-bold mb-8">
          Shopping Cart
        </h1>

        <div className="grid lg:grid-cols-3 gap-8">

          {/* LEFT SIDE */}
          <div className="lg:col-span-2 space-y-4">

            {cartItems.map((item) => (
              <div
                key={`${item.product}-${item.size}-${item.color}`}
                className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border"
              >

                {/* ✅ SMALL IMAGE FIX */}
                <img
                  src={item.photo}
                  alt={item.name}
                  className="w-20 h-20 object-cover rounded-lg border"
                />

                {/* DETAILS */}
                <div className="flex-1">

                  <h3 className="font-semibold text-gray-800">
                    {item.name}
                  </h3>

                  <p className="text-sm text-gray-500">
                    ₹{(item.finalPrice || item.price).toFixed(2)}
                  </p>

                  {/* VARIANTS */}
                  {(item.size || item.color) && (
                    <p className="text-xs text-gray-400">
                      {item.size && `Size: ${item.size}`}{" "}
                      {item.color && `| ${item.color}`}
                    </p>
                  )}

                  {/* ✅ QUANTITY FIX */}
                  <div className="flex items-center gap-2 mt-2">

                    <button
                      onClick={() =>
                        dispatch(
                          updateCartQty(
                            item.product,
                            item.quantity - 1,
                            item.size,
                            item.color
                          )
                        )
                      }
                      disabled={item.quantity <= 1}
                      className="px-2 py-1 border rounded"
                    >
                      -
                    </button>

                    <span className="px-3">
                      {item.quantity}
                    </span>

                    <button
                      onClick={() =>
                        dispatch(
                          updateCartQty(
                            item.product,
                            item.quantity + 1,
                            item.size,
                            item.color
                          )
                        )
                      }
                      className="px-2 py-1 border rounded"
                    >
                      +
                    </button>

                  </div>
                </div>

                {/* PRICE */}
                <div className="text-right">

                  <p className="font-semibold text-blue-600">
                    ₹
                    {(
                      (item.finalPrice || item.price) *
                      item.quantity
                    ).toFixed(2)}
                  </p>

                  {/* ✅ REMOVE BUTTON FIX */}
                  <button
                    onClick={() =>
                      dispatch(
                        removeFromCart(
                          item.product,
                          item.size,
                          item.color
                        )
                      )
                    }
                    className="text-red-500 text-xs mt-2 hover:underline"
                  >
                    Remove
                  </button>

                </div>
              </div>
            ))}

          </div>

          {/* RIGHT SIDE */}
          <div className="bg-white p-6 rounded-xl shadow-sm border h-fit">

            <h2 className="text-xl font-bold mb-4">
              Order Summary
            </h2>

            <div className="flex justify-between mb-2">
              <span>Subtotal</span>
              <span>₹{total.toFixed(2)}</span>
            </div>

            <div className="flex justify-between mb-2">
              <span>Shipping</span>
              <span className="text-green-600">
                Free
              </span>
            </div>

            <hr className="my-4" />

            <div className="flex justify-between font-bold text-lg mb-6">
              <span>Total</span>
              <span>₹{total.toFixed(2)}</span>
            </div>

            <button
              onClick={() => {
                if (isAuthenticated) {
                  history.push("/checkout");
                } else {
                  history.push("/login?redirect=checkout");
                }
              }}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg"
            >
              Proceed to Checkout
            </button>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Cart;